import { useEffect } from 'react';
import { useThemeStore } from '../stores/useThemeStore';

/**
 * Syncs the theme class on <html> with the store's mode.
 * Listens to `prefers-color-scheme` when mode is 'auto'.
 */
export function useThemeEffect() {
  const mode = useThemeStore((s) => s.mode);
  const setResolved = useThemeStore((s) => s.setResolved);

  useEffect(() => {
    const mql = window.matchMedia('(prefers-color-scheme: dark)');

    function apply() {
      let resolved: 'light' | 'dark';
      if (mode === 'auto') {
        resolved = mql.matches ? 'dark' : 'light';
      } else {
        resolved = mode;
      }

      const root = document.documentElement;
      if (resolved === 'dark') {
        root.classList.add('dark');
      } else {
        root.classList.remove('dark');
      }
      setResolved(resolved);
    }

    apply();

    if (mode === 'auto') {
      mql.addEventListener('change', apply);
      return () => mql.removeEventListener('change', apply);
    }
  }, [mode, setResolved]);
}
